












































































































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import { ProductSetListItem } from '@tt4b/ttam-enums';
import ProductSetIcon from '@tt4b/ttam-assets/src/svgs/creative/product_set_icon.svg';
import OperationList from '@/components/common/operation-list/index.vue';
import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from './../../../../utils/index';
import { productSetDropdownEditClick, productSetEditChoose } from './../../../../track/edit-event';

type ProductSetOption = {
  value: string;
  label: string;
} & ProductSetListItem;

const name = 'ttam-product-details-product-set';
export default defineComponent({
  name,
  components: {
    ProductSetIcon,
    OperationList,
  },
  props: {
    productSetList: {
      type: Array as PropType<ProductSetListItem[]>,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hideCreateOperation: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { productSetList, value, isLoading, hideCreateOperation, isEdit } = toRefs(props);
    const options = computed<Array<ProductSetOption>>(() =>
      (productSetList.value || []).map(item => ({
        value: item.id,
        label: item.name,
        ...item,
      })),
    );

    const productSet = computed(() => productSetList.value?.find?.(set => set.id === value.value) ?? {});

    // 部分加载失败，count = -1 的为加载失败
    const isPartialFail = computed(() => Boolean(productSetList.value?.find?.(set => set.count < 0)));

    const handleSelectChange = val => {
      emit('products-detail-product-set-change', val);
      isEdit.value && productSetEditChoose();
    };

    const onCreate = (psetId: string) => {
      emit('products-detail-product-create-set', psetId);
      trackEvent('module_ad_creative_nonshop_product_set_create');
    };

    const operationList = computed(() =>
      hideCreateOperation.value
        ? [
            {
              icon: 'vi-icon2-refresh',
              click: () => {
                emit('products-detail-product-set-refresh');
              },
              loading: isLoading.value,
              hint: i18n.t('common_refresh'),
              trackProps: {
                'data-tea-click': 'module_ad_refresh_pset_click',
              },
            },
          ]
        : [
            {
              icon: 'vi-icon2-refresh',
              click: () => {
                emit('products-detail-product-set-refresh');
              },
              loading: isLoading.value,
              hint: i18n.t('common_refresh'),
              trackProps: {
                'data-tea-click': 'module_ad_refresh_pset_click',
              },
            },
            {
              icon: 'vi-icon2-add',
              click: onCreate,
              hint: i18n.t('adgroup_create_title'),
              trackProps: {
                'data-tea-click': 'module_ad_create_pset_click',
              },
            },
          ],
    );

    const handleVisibleChange = visible => {
      if (visible) {
        trackEvent('module_ad_creative_nonshop_product_set_dropdown_click');
        isEdit.value && productSetDropdownEditClick();
      }
    };

    return {
      productSet,
      name,
      options,
      isPartialFail,
      handleSelectChange,
      onCreate,
      handleVisibleChange,
      operationList,
    };
  },
});
